module.exports = __webpack_public_path__ + "static/img/img-19.439fc8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-19.png
// module id = hC5X
// module chunks = 1